/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown>, product: NonNullable<unknown> }} Warm_Pale_Gecko_FetchInputs */

const en_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Restore your ${i?.displayName} purchase on this device by logging in to your Brave account.`);
	return /** @type {LocalizedString} */ (`Restore your ${i?.displayName} subscription on this device by logging in to your Brave account.`)
	
};

const id_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pulihkan pembelian ${i?.displayName} Anda di device ini dengan masuk ke account Brave Anda.`);
	return /** @type {LocalizedString} */ (`Pulihkan langganan ${i?.displayName} Anda di perangkat ini dengan login ke akun Brave.`)
	
};

const ms_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pulihkan pembelian ${i?.displayName} anda pada peranti ini dengan log masuk ke akaun Brave anda.`);
	return /** @type {LocalizedString} */ (`Pulihkan langganan ${i?.displayName} anda di peranti ini dengan log masuk ke akaun Brave anda.`)
	
};

const ca_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Restaura la teva compra de ${i?.displayName} en aquest aparell iniciant sessió al teu compte de Brave.`);
	return /** @type {LocalizedString} */ (`Per restaurar la teva subscripció ${i?.displayName} en aquest dispositiu, inicia sessió al teu compte de Brave.`)
	
};

const cs_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Obnovte svůj nákup ${i?.displayName} na tomto zařízení přihlášením k vašemu účtu Brave.`);
	return /** @type {LocalizedString} */ (`Obnovte své předplatné ${i?.displayName} na tomto zařízení, přihlaste se do svého účtu Brave.`)
	
};

const da_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Gendan dit ${i?.displayName}-køb på denne enhed ved at logge ind på din Brave-konto.`);
	return /** @type {LocalizedString} */ (`Gendan dit ${i?.displayName}-abonnement på denne enhed ved at logge ind på din Brave-konto.`)
	
};

const de_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Stellen Sie Ihren ${i?.displayName}-Kauf auf diesem Gerät wieder her, indem Sie sich bei Ihrem Brave-Konto anmelden.`);
	return /** @type {LocalizedString} */ (`Stellen Sie Ihr ${i?.displayName}-Abonnement auf diesem Gerät wieder her, indem Sie sich bei Ihrem Brave-Konto anmelden.`)
	
};

const et_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Taasta oma ${i?.displayName} ost sellel seadmel, logides sisse oma Brave'i kontole.`);
	return /** @type {LocalizedString} */ (`Taastage teenuse ${i?.displayName} tellimus sellel seadmel, logides sisse Brave'i kontole.`)
	
};

const es_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Restaura tu compra de ${i?.displayName} en este dispositivo iniciando sesión en tu cuenta de Brave.`);
	return /** @type {LocalizedString} */ (`Restaura tu suscripción de ${i?.displayName} en este dispositivo iniciando sesión en tu cuenta de Brave.`)
	
};

const fr_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Restaurez votre achat ${i?.displayName} sur cet appareil en vous connectant à votre compte Brave.`);
	return /** @type {LocalizedString} */ (`Restaurez votre abonnement ${i?.displayName} sur cet appareil en vous connectant à votre compte Brave.`)
	
};

const hr_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Obnovite svoju ${i?.displayName} kupnju na ovom uređaju prijavom na svoj Brave račun.`);
	return /** @type {LocalizedString} */ (`Obnovite svoju pretplatu za ${i?.displayName} na ovom uređaju tako što ćete se prijaviti na svoj račun Brave.`)
	
};

const it_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ripristina il tuo acquisto ${i?.displayName} su questo dispositivo accedendo al tuo account Brave.`);
	return /** @type {LocalizedString} */ (`Ripristina l'abbonamento a ${i?.displayName} su questo dispositivo effettuando l'accesso al tuo account Brave.`)
	
};

const lv_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Atjaunojiet savu ${i?.displayName} pirkumu šajā ierīcē, piesakoties Brave kontā.`);
	return /** @type {LocalizedString} */ (`Atjaunojiet savu ${i?.displayName} abonementu šajā ierīcē, pierakstoties savā Brave kontā.`)
	
};

const lt_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Atkurkite savo ${i?.displayName} pirkinį šiame įrenginyje, prisijungdami prie savo Brave paskyros.`);
	return /** @type {LocalizedString} */ (`Atkurti ${i?.displayName} prenumeratą šiame įrenginyje prisijungiant prie savo „Brave“ paskyros.`)
	
};

const hu_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Állítsd vissza a ${i?.displayName} vásárlásodat ezen az eszközön a Brave-fiókodba történő bejelentkezéssel.`);
	return /** @type {LocalizedString} */ (`Állítsa vissza a ${i?.displayName} előfizetését ezen az eszközön, ha bejelentkezik Brave-fiókjába.`)
	
};

const nl_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Herstel je ${i?.displayName}-aankoop op dit device door in te loggen op je Brave-account.`);
	return /** @type {LocalizedString} */ (`Hervat je ${i?.displayName}-abonnement op dit apparaat door in te loggen op je Brave-account.`)
	
};

const nb_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Gjenopprett ditt ${i?.displayName}-kjøp på denne enheten ved å logge inn på din Brave-konto.`);
	return /** @type {LocalizedString} */ (`Gjenopprett ${i?.displayName}-abonnementet på denne enheten ved å logge inn på Brave-kontoen din.`)
	
};

const pl_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Aby przywrócić zakup ${i?.displayName} na tym urządzeniu, zaloguj się do swojego konta Brave.`);
	return /** @type {LocalizedString} */ (`Aby przywrócić subskrypcję ${i?.displayName} na tym urządzeniu, zaloguj się na swoje konto Brave.`)
	
};

const pt_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Restaure sua compra do ${i?.displayName} neste dispositivo fazendo login na sua conta Brave.`);
	return /** @type {LocalizedString} */ (`Restaure sua assinatura ${i?.displayName} neste dispositivo entrando na sua conta Brave.`)
	
};

const ro_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Restaurează achiziția ta ${i?.displayName} pe acest dispozitiv conectându-te la contul tău Brave.`);
	return /** @type {LocalizedString} */ (`Restabilește abonamentul ${i?.displayName} pe acest dispozitiv conectându-te la contul Brave.`)
	
};

const sk_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Obnovte svoj nákup ${i?.displayName} na tomto zariadení prihlásením do svojho účtu Brave.`);
	return /** @type {LocalizedString} */ (`Obnovte svoje predplatné ${i?.displayName} na tomto zariadení prihlásením sa do svojho účtu Brave.`)
	
};

const sl_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Obnovite svoj nakup ${i?.displayName} na tej napravi tako, da se prijavite v svoj račun Brave.`);
	return /** @type {LocalizedString} */ (`Obnovite naročnino na »${i?.displayName}« v tej napravi tako, da se prijavite v račun Brave.`)
	
};

const fi_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Palauta ${i?.displayName}-ostoksesi tällä laitteella kirjautumalla Brave-tilillesi.`);
	return /** @type {LocalizedString} */ (`Palauta ${i?.displayName}-tilauksesi tällä laitteella kirjautumalla Brave-tilillesi.`)
	
};

const sv_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Återställ ditt ${i?.displayName}-köp på den här enheten genom att logga in på ditt Brave-konto.`);
	return /** @type {LocalizedString} */ (`Återställ din ${i?.displayName}-prenumeration på den här enheten genom att logga in på ditt Brave-konto.`)
	
};

const vi_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Khôi phục mua hàng ${i?.displayName} của bạn trên thiết bị này bằng cách đăng nhập vào tài khoản Brave của bạn.`);
	return /** @type {LocalizedString} */ (`Khôi phục gói đăng ký ${i?.displayName} trên thiết bị này bằng cách đăng nhập vào tài khoản Brave của bạn.`)
	
};

const tr_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Brave hesabınıza giriş yaparak ${i?.displayName} satın almanızı bu cihazda geri yükleyin.`);
	return /** @type {LocalizedString} */ (`Brave hesabınıza giriş yaparak bu cihazdaki ${i?.displayName} aboneliğinizi geri yükleyin.`)
	
};

const el_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Επαναφέρετε την αγορά σας ${i?.displayName} σε αυτή τη συσκευή συνδεόμενοι στον λογαριασμό σας Brave.`);
	return /** @type {LocalizedString} */ (`Επαναφέρετε τη συνδρομή σας ${i?.displayName} σε αυτήν τη συσκευή, αφού συνδεθείτε στον λογαριασμό σας στο Brave.`)
	
};

const bg_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Възстановете покупката си на ${i?.displayName} на това устройство, като влезете в своя Brave акаунт.`);
	return /** @type {LocalizedString} */ (`Възстанови абонамента си за ${i?.displayName} на това устройство, като влезеш в своя акаунт в Brave.`)
	
};

const ru_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Восстановите свою покупку ${i?.displayName} на этом устройстве, войдя в свой аккаунт Brave.`);
	return /** @type {LocalizedString} */ (`Восстановите подписку ${i?.displayName} на этом устройстве, войдя в свою учетную запись Brave.`)
	
};

const sr_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Обновите своју ${i?.displayName} куповину на овом уређају пријављивањем на свој Brave account.`);
	return /** @type {LocalizedString} */ (`Активирајте претплату на функцију ${i?.displayName} на овом уређају без пријаве на Brave налог.`)
	
};

const uk_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Відновіть свою покупку ${i?.displayName} на цьому пристрої, увійшовши до свого облікового запису Brave.`);
	return /** @type {LocalizedString} */ (`Відновіть підписку ${i?.displayName} на цьому пристрої, увійшовши до свого облікового запису Brave.`)
	
};

const ka_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`აღადგინეთ თქვენი ${i?.displayName} შეძენა ამ მოწყობილობაზე თქვენს Brave ანგარიშში შესვლით.`);
	return /** @type {LocalizedString} */ (`აღადგინეთ თქვენი ${i?.displayName} გამოწერა ამ მოწყობილობაზე თქვენს Brave ანგარიშში შესვლით.`)
	
};

const hi_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`अपने Brave account में लॉग इन करके इस डिवाइस पर अपनी ${i?.displayName} खरीद को पुनर्स्थापित करें।`);
	return /** @type {LocalizedString} */ (`अपने ब्रेव अकाउंट में लॉग इन करके इस डिवाइस पर अपनी ${i?.displayName} सब्सक्रिप्शन रिस्टोर करें।`)
	
};

const th_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`กู้คืนการซื้อ ${i?.displayName} ของคุณบนอุปกรณ์เครื่องนี้โดยการเข้าสู่ระบบบัญชี Brave ของคุณ`);
	return /** @type {LocalizedString} */ (`กู้คืนการเป็นสมาชิก ${i?.displayName} ของคุณบนอุปกรณ์นี้โดยเข้าสู่ระบบบัญชี Brave ของคุณ`)
	
};

const ko_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Brave 계정에 로그인하여 이 디바이스에서 ${i?.displayName} 구매를 복원하세요.`);
	return /** @type {LocalizedString} */ (`Brave 계정에 로그인하여 이 기기의 ${i?.displayName} 구독을 복원하세요.`)
	
};

const zh_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`登录您的 Brave 账户，以在这台设备上恢复您的 ${i?.displayName} 订阅。`)
};

const zh_tw_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`登入您的 Brave 帳戶，即可在此裝置上還原您的 ${i?.displayName} 購買。`);
	return /** @type {LocalizedString} */ (`請登入您的 Brave 帳戶，在此裝置上恢復您的 ${i?.displayName} 訂閱服務。`)
	
};

const ja_warm_pale_gecko_fetch = /** @type {(inputs: Warm_Pale_Gecko_FetchInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Brave アカウントにログインして、このデバイスで ${i?.displayName} の購入を復元してください。`);
	return /** @type {LocalizedString} */ (`Braveアカウントにログインして、このデバイスの ${i?.displayName} サブスクリプションを復元してください。`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "Restore your {displayName} purchase on this device by logging in to your Brave account." |
* | * | "Restore your {displayName} subscription on this device by logging in to your Brave account." |
*
* @param {Warm_Pale_Gecko_FetchInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const warm_pale_gecko_fetch = /** @type {((inputs: Warm_Pale_Gecko_FetchInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Pale_Gecko_FetchInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_warm_pale_gecko_fetch(inputs)
	if (locale === "ms") return ms_warm_pale_gecko_fetch(inputs)
	if (locale === "ca") return ca_warm_pale_gecko_fetch(inputs)
	if (locale === "cs") return cs_warm_pale_gecko_fetch(inputs)
	if (locale === "da") return da_warm_pale_gecko_fetch(inputs)
	if (locale === "de") return de_warm_pale_gecko_fetch(inputs)
	if (locale === "et") return et_warm_pale_gecko_fetch(inputs)
	if (locale === "es") return es_warm_pale_gecko_fetch(inputs)
	if (locale === "fr") return fr_warm_pale_gecko_fetch(inputs)
	if (locale === "hr") return hr_warm_pale_gecko_fetch(inputs)
	if (locale === "it") return it_warm_pale_gecko_fetch(inputs)
	if (locale === "lv") return lv_warm_pale_gecko_fetch(inputs)
	if (locale === "lt") return lt_warm_pale_gecko_fetch(inputs)
	if (locale === "hu") return hu_warm_pale_gecko_fetch(inputs)
	if (locale === "nl") return nl_warm_pale_gecko_fetch(inputs)
	if (locale === "nb") return nb_warm_pale_gecko_fetch(inputs)
	if (locale === "pl") return pl_warm_pale_gecko_fetch(inputs)
	if (locale === "pt") return pt_warm_pale_gecko_fetch(inputs)
	if (locale === "ro") return ro_warm_pale_gecko_fetch(inputs)
	if (locale === "sk") return sk_warm_pale_gecko_fetch(inputs)
	if (locale === "sl") return sl_warm_pale_gecko_fetch(inputs)
	if (locale === "fi") return fi_warm_pale_gecko_fetch(inputs)
	if (locale === "sv") return sv_warm_pale_gecko_fetch(inputs)
	if (locale === "vi") return vi_warm_pale_gecko_fetch(inputs)
	if (locale === "tr") return tr_warm_pale_gecko_fetch(inputs)
	if (locale === "el") return el_warm_pale_gecko_fetch(inputs)
	if (locale === "bg") return bg_warm_pale_gecko_fetch(inputs)
	if (locale === "ru") return ru_warm_pale_gecko_fetch(inputs)
	if (locale === "sr") return sr_warm_pale_gecko_fetch(inputs)
	if (locale === "uk") return uk_warm_pale_gecko_fetch(inputs)
	if (locale === "ka") return ka_warm_pale_gecko_fetch(inputs)
	if (locale === "hi") return hi_warm_pale_gecko_fetch(inputs)
	if (locale === "th") return th_warm_pale_gecko_fetch(inputs)
	if (locale === "ko") return ko_warm_pale_gecko_fetch(inputs)
	if (locale === "zh") return zh_warm_pale_gecko_fetch(inputs)
	if (locale === "zh-tw") return zh_tw_warm_pale_gecko_fetch(inputs)
	if (locale === "ja") return ja_warm_pale_gecko_fetch(inputs)
	return en_warm_pale_gecko_fetch(inputs)
});